export default "__VITE_ASSET__C9hZU9NH__"